import { NewsInterface } from "../../domain/interfaces/news_interface";
import { NewsRepository } from "../../domain/repository/news_repository";
import { ActualityApiService } from "../data_source/actuality_api_service";

export class NewsRepositoryImpl implements NewsRepository {
    private newsApiService: ActualityApiService;

    constructor() {
        this.newsApiService = new ActualityApiService();
    }

    async getNews(skip: number, limit: number): Promise<{ news: NewsInterface[], fetchedAll: boolean }> {
        const response = await this.newsApiService.getNews(skip, limit);
        if (response.status === 200) {
            const news: NewsInterface[] = [];
            const now = new Date();
            for (const item of response.data.objects) {
                const startDate = new Date(item.startDate);
                const endDate = new Date(item.endDate);
                if (item.active && startDate <= now && endDate >= now) {
                    news.push({
                        id: item._id,
                        ...item,
                    });
                }
            }
            return { news, fetchedAll: response.data.pages <= (skip / limit) + 1 };
        }
        throw new Error("Failed to fetch news");
    }
}